import { DisplayLayer } from '../DisplayLayer';

export class Scene extends DisplayLayer {

   preload?(...args: any): any{}
}